import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderConfirm from "./pages/OrderConfirm";
import LoginModal from "./components/LoginModal";
import Contatti from "./pages/Contatti"
import "./App.css";

const App = () => {
  const [cartItems, setCartItems] = useState(() => {
    const saved = localStorage.getItem("cartItems");
    return saved ? JSON.parse(saved) : [];
  });

  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("currentUser");
    return saved ? JSON.parse(saved) : null;
  });

  const [showLoginModal, setShowLoginModal] = useState(false);
  const [lastOrder, setLastOrder] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          "https://raw.githubusercontent.com/nikfaccini/Progetto-ERASMUS-2026/refs/heads/main/src/catalogo/catalogo.json"
        );
        const data = await response.json();
        const mappedProducts = data.catalogo.prodotti.map((prod) => ({
          id: prod.id,
          name: prod.nome,
          image: prod.immagine,
          category: prod.categoria.toLowerCase().replace(" ", "-"),
          shortDesc: prod.descrizione,
          price: prod.prezzo,
          description: prod.descrizione,
          specifications: {
            dimensions: prod.dimensioni_cm,
            weight: `${prod.peso_kg} kg`,
            material: prod.materiale,
            type: prod.categoria,
          },
          stock: prod.disponibilita,
          reviews: Math.floor(Math.random() * 400 + 50),
          discount: Math.random() > 0.7 ? Math.floor(Math.random() * 20 + 5) : 0,
        }));
        setProducts(mappedProducts);
        setLoading(false);
      } catch (error) {
        console.error("Errore nel caricamento catalogo:", error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  useEffect(() => {
    if (user) {
      localStorage.setItem("currentUser", JSON.stringify(user));
    }
  }, [user]);

  const addToCart = (product) => {
    setCartItems((prevItems) => {
      const existingItem = prevItems.find((item) => item.id === product.id);
      if (existingItem) {
        return prevItems.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + (product.quantity || 1) }
            : item
        );
      }
      return [...prevItems, { ...product, quantity: product.quantity || 1 }];
    });
  };

  const removeFromCart = (productId) => {
    setCartItems((prevItems) =>
      prevItems.filter((item) => item.id !== productId)
    );
  };

  const updateQuantity = (productId, quantity) => {
    if (quantity <= 0) {
      removeFromCart(productId);
      return;
    }
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === productId ? { ...item, quantity } : item
      )
    );
  };

  const clearCart = () => {
    setCartItems([]);
  };

  return (
    <BrowserRouter>
      {showLoginModal && (
        <LoginModal onClose={() => setShowLoginModal(false)} onLogin={setUser} />
      )}
      <Header
        cartCount={cartItems.length}
        user={user}
        onLogout={() => setUser(null)}
        onOpenLogin={() => setShowLoginModal(true)}
      />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Home addToCart={addToCart} products={products} loading={loading} />} />
          <Route
            path="/products"
            element={<Products addToCart={addToCart} products={products} loading={loading} />}
          />
          <Route
            path="/product/:id"
            element={<ProductDetail addToCart={addToCart} products={products} />}
          />
          <Route
            path="/contatti"
            element={<Contatti />}
          />
          <Route
            path="/cart"
            element={
              <Cart
                cartItems={cartItems}
                removeFromCart={removeFromCart}
                updateQuantity={updateQuantity}
                user={user}
                onOpenLogin={() => setShowLoginModal(true)}
              />
            }
          />
          <Route
            path="/checkout"
            element={
              <Checkout
                cartItems={cartItems}
                user={user}
                onOpenLogin={() => setShowLoginModal(true)}
                onOrderComplete={(order) => {
                  setLastOrder(order);
                  clearCart();
                }}
              />
            }
          />
          <Route
            path="/order-confirm"
            element={<OrderConfirm order={lastOrder} />}
          />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
